import { AudioSkinElement } from '../../presets/audio/skin';
import { safeDefine } from '../../registration/safe-define';
import './ui';

safeDefine(AudioSkinElement);
